import React from 'react'

export default function MFCard({children}) {
    return (
        <div className="card containers border border-secondary" >
            {children}
        </div>
    )
}
